var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "ci-user-profile-products" },
    [
      !_vm.loading
        ? [
            _vm.products.length > 0
              ? [
                  _c("h3", {
                    staticClass: "h5 px-3 px-md-4 px-lg-0",
                    domProps: {
                      textContent: _vm._s(
                        _vm.$t("ui.components.users.profile.products.title")
                      ),
                    },
                  }),
                  _c("ci-user-profile-slider", {
                    attrs: { items: _vm.products, "cutting-threshold": 0.25 },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                { staticClass: "w-100" },
                                [
                                  props.loaded
                                    ? _c("ci-product-tile", {
                                        staticClass: "mb-2 mb-md-3 w-100",
                                        attrs: { product: props.item[0] },
                                      })
                                    : _vm._e(),
                                  props.loaded && props.item[1]
                                    ? _c("ci-product-tile", {
                                        staticClass: "mb-0 w-100",
                                        attrs: { product: props.item[1] },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      153143000
                    ),
                  }),
                ]
              : _vm.owner
              ? [
                  _c(
                    "div",
                    {
                      staticClass:
                        "ci-card ci-section text-muted ci-content-padding mx-3 mx-md-4 mx-lg-0",
                    },
                    [
                      _c("h3", {
                        staticClass: "h5",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ui.components.users.profile.products.title")
                          ),
                        },
                      }),
                      _c("p", {
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "ui.components.users.profile.products.empty_state"
                            )
                          ),
                        },
                      }),
                      _c(
                        "div",
                        { staticClass: "row flex-center" },
                        [
                          _c("ci-button", {
                            attrs: {
                              icon: "mdi-plus",
                              label: _vm.$t(
                                "ui.components.users.profile.products.action"
                              ),
                              to: { name: _vm.$routes.PRODUCTS_SEARCH_INDEX },
                              variant: "outline-primary",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }